<div class="newsletter">
    <div class="newsletter__question"><i class="fa fa-envelope-o"></i>{{ 'COMMON.RECEIVE_NEWSLETTER_QUESTION' | translate }}</div>
    <div class="newsletter__buttons">
        <button class="btn btn--secondary btn--longer" (click)="decline()" [disabled]="isSaving" [ngClass]="{ 'is-loading': isSaving }">{{ 'COMMON.NO' | translate }}</button>
        <button class="btn btn--primary btn--longer" (click)="accept()"  [disabled]="isSaving" [ngClass]="{ 'is-loading': isSaving }">{{ 'COMMON.YES' | translate }}</button>
    </div>
</div>